import { useEffect, useState } from "react";
export function useMap(lazyMap, mount = undefined, unmount = undefined) {
    const [map, setMap] = useState();
    useEffect(() => {
        lazyMap.onLoad((map) => {
            if (mount !== undefined) {
                mount(map);
            }
            setMap(map);
        });
        if (unmount !== undefined) {
            return unmount;
        }
    }, []);
    return map;
}
//# sourceMappingURL=Hook.js.map